var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('tr',[_c('td',{attrs:{"colspan":_vm.cols}},[_vm._m(0)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"10","aria-valuemin":"0","aria-valuemax":"100"}})])
}]

export { render, staticRenderFns }